import { BaseExceptionApi } from '@/data/exceptions/BaseExceptionApi'

export class ExceptionApiAccessTokenExpired extends BaseExceptionApi {
  constructor() {
    super('ExceptionApiAccessTokenExpired', 'ACCESS_TOKEN_EXPIRED')
  }
}
